import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, watch } from 'vue';
import BaseFormCard from '@/views/base/BaseFormCard.vue';
import sharedMessages from '@/lib/shared-messages';
import { defineMessages } from '@/lib/i18n';
import { GetCompanyPeriodicExportSetting } from '@/interfaces/api/general/company';


export default /*#__PURE__*/_defineComponent({
  __name: 'PeriodicExportDeleteDialog',
  props: {
    value: { type: Boolean },
    exportSetting: null
  },
  emits: ["input", "delete"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: boolean): void;
  (
    e: 'delete',
    exportSetting: GetCompanyPeriodicExportSetting | undefined
  ): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: boolean;
  exportSetting: GetCompanyPeriodicExportSetting | undefined;
};

const m = defineMessages({
  deletePeriodicExportSetting: '定期エクスポートを削除しますか？',
});





const localValue = ref(props.value);

watch(
  () => props.value,
  (newValue) => {
    localValue.value = newValue;
  }
);

const closeDialog = () => {
  emit('input', false);
};

const handleDeleteClick = async () => {
  emit('delete', props.exportSetting);
  closeDialog();
};

onMounted(() => {
  if (!props.exportSetting) {
    closeDialog();
  }
});

return { __sfc: true,m, props, emit, localValue, closeDialog, handleDeleteClick, BaseFormCard, sharedMessages }
}

})